import loadable from 'react-loadable';

const LoadableComposeEmailModalRoot = loadable({
    loader: () => import(/* webpackChunkName: "compose-email-root" */ './ComposeEmailModalRoot'),
    loading: () => null,
});

export default LoadableComposeEmailModalRoot;
